import React, { useEffect, useState, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import { getTicket } from "../lib/ticket.js";
import { useGetTicket } from "../hooks/useGetTicket.js";
import EditTicketModal from "../components/EditTicketModal.jsx";
import CreateTicketModal from "../components/CreateTicketModal.jsx";
import CloseTicketModal from "../components/CloseTicketModal.jsx";
import OpenTicketModal from "../components/OpenTicketModal.jsx";
import { addInterventionsTicket } from "../lib/ticket.js";
import Moment from "moment";
import Sidebar from "../components/Sidebar.jsx";
import Navbar from "../components/Navbar.jsx";
import ImageViewer from "../components/ImageViewer.jsx";
import ToastNotification from "../components/ToastNotification.jsx";
import { useTickets } from "../context/TicketContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.js";
import { useUploadFichiers } from "../hooks/useUploadFichiers";
import { useDropzone } from "react-dropzone"; //drag and drop fichier
import { useGetTypesTicket } from "../hooks/useGetTypesTicket.js";
import { useGetClient } from "../hooks/useGetClient.js";
import { FaRepeat } from "react-icons/fa6";
import { relanceAvaillable } from "../utils/relance.js";
import RelanceTicketModal from "../components/askRelanceMessage.jsx";
import { getColorBasedOnStatut } from "../utils/getColor.js";

export default function DetailsTickets() {
  const [openModalOpen, setOpenModalOpen] = useState(false);
  const { ticketId } = useParams();
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const [closeModalOpen, setCloseModalOpen] = React.useState(false);
  const { filtre, setFiltre } = useAuth();
  const navigate = useNavigate();
  const [fichiers, setFichiers] = useState([]);
  const { uploadFichiers, loading: uploading, erreur } = useUploadFichiers(); // utilisation du custom hook
  const { ticket, loading, error, fetchTicket } = useGetTicket();
  const [RequestAlreadyExisted, setRequestAlreadyExisted] =
    React.useState(false);

  // Sidebar
  const [isCollapsed, setIsCollapsed] = React.useState(false);

  const {
    typesTicket,
    loading: loadingTypes,
    error: errorTypes,
  } = useGetTypesTicket();
  const [tickets, setTickets] = React.useState([]);

  //FILTRAGE + RECHERCHE
  const [searchTerm, setSearchTerm] = React.useState("");
  const [showSearchResults, setShowSearchResults] = React.useState(false);
  const [filteredTickets, setFilteredTickets] = React.useState([]);

  //TICKET STATUS
  const TICKET_STATUTS = {
    0: "Ouvert",
    1: "En cours",
    2: "Clôturé",
    3: "Approuvé",
  };

  // RELANCE
  const [showRelanceModal, setShowRelanceModal] = useState(false);
  const [selectedTicketRelance, setSelectedTicketRelance] = useState(0);

  const handleRelance = async (ticket) => {
    setSelectedTicketRelance(ticket);
    setShowRelanceModal(true);
  };

  //DRAG AND DROP POUR FICHIER

  const onDrop = useCallback((acceptedFiles) => {
    setFichiers((prev) => [...prev, ...acceptedFiles]); // ajoute les fichiers à la sélection
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const searchResultsRef = useRef(null); // Référence des résultats
  const editTicketRef = useRef(null); 
  const relanceTicketRef = useRef(null); 
  const closeTicketRef = useRef(null); 
  const openTicketRef = useRef(null); 

  const handleFichierClick = async () => {
    if (fichiers.length > 0) {
      try {
        const ids = await uploadFichiers(ticketId, fichiers);
        if (ids) {
          setToast({
            visible: true,
            type: "success",
            message: "Fichier ajouté avec succès ✅",
          });
          setFichiers([]);
          fetchTicket(ticketId);
        }
      } catch (e) {
        //
      }
    }
  };

  // Ajouter le style global au chargement du composant
  useEffect(() => {
    // Créer une feuille de style pour les barres de défilement
    const style = document.createElement("style");
    style.textContent = `
      ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      ::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb {
        background: #d1d3e2;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: #a8abb9;
      }
      * {
        scrollbar-width: thin;
        scrollbar-color: #d1d3e2 #f1f1f1;
      }
    `;
    document.head.appendChild(style);

    const handleClickOutside = (event) => {
      if (
        searchResultsRef.current &&
        !searchResultsRef.current.contains(event.target)
      ) {
        setShowSearchResults(false); // Ferme si clic en dehors
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    // Nettoyer le style lorsque le composant est démonté
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.head.removeChild(style);
    };
  }, []);

  const [toast, setToast] = React.useState({
    visible: false,
    type: "success",
    message: "",
  });

  const [createModalOpen, setCreateModalOpen] = useState(false);

  // Utilisation du contexte pour les tickets
  const { refreshTickets } = useTickets();

  const RequestAlreadyExist = () => {
    if (ticket) {
      const interventions = ticket.intervention || [];
      if (interventions.length > 0) {
        const lastIntervention = interventions[interventions.length - 1];
        if (lastIntervention?.description?.includes("DEMANDE DE CLOTURE")) {
          return true; // La demande de facturation existe déjà
        }
      }
    }
    return false; // La demande de facturation n'existe pas
  };

  useEffect(() => {
    fetchTicket(ticketId);
  }, [ticketId]);

  

  useEffect(() => {
    if (ticket) {
      setRequestAlreadyExisted(RequestAlreadyExist());
    }
  }, [ticket]);

  const handleEditTicket = () => {
    setEditModalOpen(true);
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border text-warning" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  if (!ticket) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="alert alert-danger" role="alert">
          Pas de ticket trouvé
        </div>
      </div>
    );
  }

  // Déterminer le statut pour l'affichage
  const getStatusBadge = () => {
    if (ticket.idStatut <= 1) {
      return <span className="badge bg-primary text-white">Ouvert</span>;
    } else {
      return <span className="badge bg-secondary text-white">Fermé</span>;
    }
  };

  // Formater la date pour l'affichage
  const formatDate = (dateString) => {
    if (!dateString) return "Non définie";
    return Moment(dateString).format("DD/MM/YYYY à HH:mm");
  };

  const handleFilterChange = (filter) => {
    setFiltre(filter);
    navigate(`/tickets`);
  };

  //FONCTION DE RECHERCHE EN TEMPS REEL
  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim() === "") {
      setFilteredTickets(tickets);
      setShowSearchResults(false);
      return;
    }
    const filtered = tickets.filter(
      (ticket) =>
        ticket.titre?.toLowerCase().includes(term.toLowerCase()) ||
        ticket.nomClient?.toLowerCase().includes(term.toLowerCase()) ||
        TICKET_STATUTS[ticket.idStatut]
          ?.toLowerCase()
          .includes(term.toLowerCase()) ||
        typesTicket[ticket.idType]?.toLowerCase().includes(term.toLowerCase())
    );

    setFilteredTickets(filtered);
    setShowSearchResults(true);
  };

  const selectTicket = (ticket) => {
    setSearchTerm(ticket.titre);
    setShowSearchResults(false);
    setFilteredTickets([ticket]);
  };

  return (
    <div className="App">
      <div id="wrapper" className={isCollapsed ? "sidebar-toggled" : ""}>
        <Sidebar
          isOnTicketPage={true}
          onFilterChange={handleFilterChange}
          filtre={filtre}
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          onCreateTicket={() => setCreateModalOpen(true)}
        />
        <Navbar
          isOnTicketPage={true}
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
          showSearchResults={showSearchResults}
          setShowSearchResults={setShowSearchResults}
          filteredTickets={filteredTickets}
          selectTicket={selectTicket}
          typesTicket={typesTicket}
          TICKET_STATUTS={TICKET_STATUTS}
          isSidebarCollapse={isCollapsed}
        />
        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
           {showRelanceModal &&
            <RelanceTicketModal 
              onClose={() => setShowRelanceModal(false)} 
              onSubmitSuccess={
                async () => {
                  setToast({
                    visible: true,
                    type: "success",
                    message: "Relance effectuée avec succès",
                  });
                    await fetchTicket(ticketId);
                }}
              onError={
                async () => {
                  setToast({
                    visible: true,
                    type: "error",
                    message: "Echec de la demande de relance",
                  });
                  await refreshTickets();
                }} 
              ticket={selectedTicketRelance}
            />
          }
          {toast.visible && (
            <ToastNotification
              message={toast.message}
              type={toast.type}
              onClose={() => setToast({ visible: false })}
            />
          )}

          {/* <!-- Scroll to Top Button--> */}
          <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
          </a>
          {/* <!-- Begin Page Content --> */}
          <div className="container-fluid custom-container">
            {/* <!-- Page Heading --> */}
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1
                id="titre"
                className="h3 mb-0 text-gray-500"
                style={{ display: "flex", alignItems: "center" }}
              >
                <i className="fas fa-ticket-alt me-2"></i>
                {ticket.titre}{" "}
              </h1>
              <div className="d-flex">
                {ticket.idStatut != 3 && 
                  <button
                    className={`me-4 btn ${
                      relanceAvaillable(ticket)
                        ? "btn-primary"
                        : "btn-secondary"
                    } "m-1"`}
                    disabled={
                      !relanceAvaillable(ticket) || ticket.idStatut == 2
                    }
                    onClick={async () => {
                      // Créer une intervention de 1 min
                      handleRelance(ticket);
                    }}
                    data-testid="relance-ticket-button"
                  >
                    <FaRepeat />
                  </button>
                }
                {ticket.idStatut <= 1 && RequestAlreadyExisted == false && (
                  <button
                    id="facturerTicketBtn"
                    className="btn btn-close-action shadow-sm d-flex align-items-center"
                    type="button"
                    onClick={() => setCloseModalOpen(true)}
                    data-testid="close-ticket-button"
                  >
                    <i className="fas fa-check-circle me-2"></i>
                    Demander à clôturer
                  </button>
                )}
                {ticket.idStatut == 2 && (
                  <button
                    id="ouvrirTicketBtn"
                    className="btn btn-warning-action shadow-sm ms-2"
                    type="button"
                    onClick={() => setOpenModalOpen(true)}
                    data-testid="open-ticket-button"
                  >
                    <i className="fas fa-lock-open me-2"></i>
                    Ré-ouvrir le ticket
                  </button>
                )}
              </div>
            </div>

            <div className="row">
              {/* Colonne principale pour Détails et Interventions */}
              <div className="col-lg-8 mb-4">
                {/* Info Ticket Card - Fusionné avec Description */}
                <div
                  className="card shadow mb-4"
                  style={{
                    borderRadius: "12px",
                    border: "none",
                    overflow: "hidden",
                  }}
                >
                  <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between border-bottom-0 bg-white">
                    <h6
                      className="m-0 fw-bold"
                      style={{ color: "var(--warning)" }}
                    >
                      <i className="fas fa-info-circle me-2"></i> Détails du
                      ticket
                    </h6>
                    {!RequestAlreadyExist() && ticket.idStatut <= 1 && (
                      <button
                        id="editTicketBtn"
                        type="button"
                        className="btn btn-warning-action btn-sm shadow-sm"
                        onClick={handleEditTicket}
                        data-testid="edit-ticket-button"
                      >
                        <i className="fas fa-edit me-1"></i> Modifier
                      </button>
                    )} 
                  </div>
                  <div className="card-body bg-light">
                    <div className="row">
                      {/* Partie info générale */}
                      <div className="col-md-5 border-end">
                        <div className="d-flex mb-3">
                          <div className="icon-circle-sm bg-light me-3 d-flex justify-content-center">
                            <i
                              className="fas fa-calendar"
                              style={{ color: "var(--warning)" }}
                            ></i>
                          </div>
                          <div>
                            <div
                              className="text-xs fw-bold text-uppercase mb-1"
                              style={{ color: "var(--dark)" }}
                            >
                              Date de début
                            </div>
                            <div className="text-gray-800 h6">
                              {ticket.dateDebut}
                            </div>
                          </div>
                        </div>

                        <div className="d-flex mb-3">
                          <div className="icon-circle-sm bg-light me-3 d-flex justify-content-center">
                            <i
                              className="fas fa-flag"
                              style={{ color: "var(--warning)" }}
                            ></i>
                          </div>
                          <div>
                            <div
                              className="text-xs fw-bold text-uppercase mb-1"
                              style={{ color: "var(--dark)" }}
                            >
                              Statut
                            </div>
                            <div
                              className="badge px-2 py-1 "
                              style={{
                                backgroundColor: getColorBasedOnStatut(ticket.idStatut),
                                color: "white",
                                fontWeight: "500",
                                borderRadius: "4px",
                                fontWeight: "bold",
                              }}
                            >
                              {TICKET_STATUTS[ticket.idStatut] || "N/A"}
                            </div>
                          </div>
                        </div>

                        <div className="d-flex mb-3">
                          <div className="icon-circle-sm bg-light me-3 d-flex justify-content-center">
                            <i
                              className="fas fa-users"
                              style={{ color: "var(--warning)" }}
                            ></i>
                          </div>
                          <div style={{ width: "100%" }}>
                            <div
                              className="text-xs fw-bold text-uppercase mb-1"
                              style={{ color: "var(--dark)" }}
                            >
                              Intervenant(s)
                            </div>
                            {(ticket.intervenant?.length ?? 0) > 0 ? (
                              <div className="d-flex flex-wrap mt-1">
                                {(ticket.intervenant ?? []).map((intervenant) => (
                                  <div
                                    key={intervenant.idIntervenant}
                                    className="mb-1 me-1"
                                  >
                                    <span
                                      className="badge bg-light text-dark border p-2 shadow-sm"
                                      style={{
                                        fontSize: "0.8rem",
                                        borderLeft: "3px solid var(--warning)",
                                      }}
                                    >
                                      <i
                                        className="fas fa-user-tie me-1"
                                        style={{ color: "var(--warning)" }}
                                      ></i>{" "}
                                      {intervenant.nom}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="text-gray-500 font-italic">
                                Aucun intervenant assigné
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Partie description */}
                      <div className="col-md-7">
                        <div
                          className="text-xs fw-bold text-uppercase mb-2"
                          style={{ color: "var(--dark)" }}
                        >
                          <i
                            className="fas fa-align-left me-1"
                            style={{ color: "var(--dark)" }}
                          ></i>{" "}
                          Description
                        </div>
                        <div
                          className="p-3"
                          style={{
                            minHeight: "150px",
                            fontSize: "0.95rem",
                            lineHeight: "1.5",
                          }}
                        >
                          <p className="text-gray-800 mb-0">
                            {ticket.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Interventions Card */}
                {(ticket.intervention?.length ?? 0) > 0 && (
                  <div
                    className="card shadow"
                    style={{
                      borderRadius: "12px",
                      border: "none",
                      overflow: "hidden",
                    }}
                  >
                    <div className="card-header py-3 bg-white border-bottom-0">
                      <h6
                        className="m-0 fw-bold"
                        style={{ color: "var(--primary)" }}
                      >
                        <i
                          className="fas fa-history me-2"
                          style={{ color: "var(--primary)" }}
                        ></i>{" "}
                        Historique des interventions
                      </h6>
                    </div>
                    <div className="card-body p-0">
                      <div
                        className="table-responsive"
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          scrollbarWidth: "thin",
                          scrollbarColor: "#d1d3e2 transparent",
                        }}
                      >
                        <table className="table table-sm table-hover mb-0">
                          <thead style={{ backgroundColor: "#f8f9fc" }}>
                            <tr>
                              <th className="px-3">
                                <i
                                  className="fas fa-calendar-day me-1"
                                  style={{ color: "var(--primary)" }}
                                ></i>{" "}
                                Date
                              </th>
                              <th className="px-3">
                                <i
                                  className="fas fa-comment-alt me-1"
                                  style={{ color: "var(--primary)" }}
                                ></i>{" "}
                                Description
                              </th>
                              <th className="px-3">
                                <i
                                  className="fas fa-user me-1"
                                  style={{ color: "var(--primary)" }}
                                ></i>{" "}
                                Intervenant
                              </th>
                              <th className="px-3">
                                <i
                                  className="fas fa-clock me-1"
                                  style={{ color: "var(--primary)" }}
                                ></i>{" "}
                                Durée
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {(ticket.intervention ?? []).map((intervention, index) => (
                              <tr
                                key={intervention.idIntervention}
                                className={index % 2 === 0 ? "bg-light" : ""}
                              >
                                <td className="px-3">{intervention.date}</td>
                                <td className="px-3">
                                  {intervention.description}
                                </td>
                                <td className="px-3">{intervention.nom}</td>
                                <td className="px-3">
                                  {intervention.duree} min
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Colonne de droite pour Fichiers */}
              <div className="col-lg-4 mb-4">
                {/* Files Card */}
                <div
                  className="card shadow h-100"
                  style={{
                    borderRadius: "12px",
                    border: "none",
                    overflow: "hidden",
                  }}
                >
                  <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between bg-white border-bottom-0">
                    <h6
                      className="m-0 fw-bold"
                      style={{ color: "var(--success)" }}
                    >
                      <i
                        className="fas fa-file-alt me-2"
                        style={{ color: "var(--success)" }}
                      ></i>{" "}
                      Fichiers
                    </h6>
                    {ticket.idStatut <= 1 && fichiers.length != 0 && (
                      <button
                        className="btn btn-success btn-sm shadow-sm"
                        onClick={handleFichierClick}
                      >
                        <i className="fas fa-plus me-1"></i> Ajouter
                      </button>
                    )}
                  </div>
                  <div
                    className="card-body bg-light d-flex flex-wrap justify-content-center align-items-start  "
                    style={{
                      overflowY: "auto",
                      scrollbarWidth: "thin",
                      scrollbarColor: "#d1d3e2 transparent",
                    }}
                  >
                    <div className="p-2 ">
                      <ImageViewer
                        idTicket={ticket.idTicket}
                        statutTicket={ticket.idStatut}
                        nomFichiers={(ticket.fichier ?? []).map((f) => f.fichier)}
                      />
                    </div>
                    {ticket.idStatut !== 2 && (
                      <div
                        {...getRootProps()}
                        className={`dropzone-area border border-secondary gap-3 p-3 text-center align-self-start${isDragActive ? " dropzone-area--active" : ""}`}
                      >
                        <label>Ajouter des fichiers à votre ticket</label>
                        <input
                          {...getInputProps()}
                          style={{ display: "none" }}
                        />
                        {isDragActive ? (
                          <p className="text-success">
                            Déposez les fichiers ici...
                          </p>
                        ) : (
                          <p>
                            Glissez-déposez des fichiers ici, ou cliquez pour en
                            sélectionner puis appuyez sur Ajouter
                          </p>
                        )}
                        {fichiers.length > 0 && (
                          <ul className="list-unstyled mt-2">
                            {Array.from(fichiers).map((file, index) => (
                              <li key={index}>📎 {file.name}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Niralakka 2025</span>
            </div>
          </div>
        </footer>
      </div>
      {/* End of content-wrapper */}
      </div>
      {/* End of #wrapper */}

      {/* Modals */}
      {editModalOpen && ticket && ticket.idStatut <= 1 && (
        <EditTicketModal
          ticket={ticket}
          ticketDetails={ticket}
          onClose={() => setEditModalOpen(false)}
          onSubmitSuccess={async () => {
            setToast({
              visible: true,
              type: "success",
              message: "Ticket modifié avec succès ✅",
            });
            await fetchTicket(ticketId);
            await refreshTickets();
          }}
          onError={() => {
            setToast({
              visible: true,
              type: "error",
              message: "Echec de la modification du ticket ❌",
            });
          }}
        />
      )}

      {closeModalOpen && (
        <CloseTicketModal
          ticket={ticket}
          onClose={() => setCloseModalOpen(false)}
          onSubmitSuccess={async () => {
            setToast({
              visible: true,
              type: "success",
              message: "Ticket cloturé avec succès ✅",
            });
            await fetchTicket(ticketId);
            await refreshTickets();
          }}
          onError={() => {
            setToast({
              visible: true,
              type: "error",
              message: "Echec lors de la cloture du ticket ❌",
            });
          }}
        />
      )}

      {openModalOpen && (
        <OpenTicketModal
          ticket={ticket}
          onClose={() => setOpenModalOpen(false)}
          onSubmitSuccess={async () => {
            setToast({
              visible: true,
              type: "success",
              message: "Ticket réouvert avec succès ✅",
            });
            await fetchTicket(ticketId);
            await refreshTickets();
          }}
          onError={() => {
            setToast({
              visible: true,
              type: "error",
              message: "Echec lors de la réouverture du ticket ❌",
            });
          }}
        />
      )}

      {createModalOpen && (
        <CreateTicketModal
          onClose={() => setCreateModalOpen(false)}
          onSubmitSuccess={() => {
            setCreateModalOpen(false);
            setToast({ visible: true, type: "success", message: "Ticket créé avec succès ✅" });
          }}
          onError={() => setToast({ visible: true, type: "error", message: "Échec de la création ❌" })}
        />
      )}

      {/* Scroll to Top Button */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
    </div>
  );
}
